import axios from 'axios'
import axiosRetry from 'axios-retry'

import { errorMsg } from '../components/Shared/Notification/ToastNotification';
import { SessionStorage } from '../util/SessionStorage'
import { formatData, isEmptyObject } from '../util/utils';
import { dynamicUrl } from "../helper/dynamicUrls";
import * as Constants from '../helper/constants';

export const axiosInstance = axios.create({
    baseURL: `${dynamicUrl}`,
    headers: { 'Authorization': SessionStorage.getItem("user_jwt") },
    timeout: 10000
});


const retryDelay = (retryNumber = 0) => {
    const seconds = Math.pow(2, retryNumber) * 1000;
    // Safe to use Math.random here for non-secure retry jitter
    const randomMs = 1000 * Math.random();
    return seconds + randomMs;
};

axiosRetry(axiosInstance, {
    retries: 2,
    retryDelay,
    // retry on Network Error & 5xx responses
    retryCondition: axiosRetry.isRetryableError,
});

const DEBUG = process.env.NODE_ENV === "development";

function errorResponseHandler(error) {
    var element = document.getElementById("overlay");
    if (element && element.parentNode) {
        element.parentNode.removeChild(element);
    }

    if (DEBUG) { console.error(`Error: ${formatData(error)}`); }

    if (error.response && error.response.data) {
        errorMsg(error.response.data);
        if (error.response.data === "Invalid Token") {
            const user_type = SessionStorage.getItem('user_type');
            if (user_type && user_type === Constants.PortalUserRoles.ClientUserTypes.Employee) {
                SessionStorage.clearAll();
                window.location.href = '/auth/employeeLogin';
            } else {
                SessionStorage.clearAll();
                window.location.href = '/';
            }
        }
    }
    else if (error.message) {
        errorMsg(error.message);
    } else {
        errorMsg("Please contact message... 9999999999");
    }
    return Promise.reject(error);
}

// Add a request interceptor
axiosInstance.interceptors.request.use(function (config) {
    if (DEBUG) { console.info(`Request: ${formatData(config)}`); }

    return config;
}, errorResponseHandler);

// apply interceptor on response
axiosInstance.interceptors.response.use(function (response) {
    if (DEBUG) { console.info(`Response: ${formatData(response)}`); }

    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, errorResponseHandler);

export const getAPICall = async (url, data) => await axiosInstance.get(url, data);
export const postAPICall = async (url, data) => await axiosInstance.post(url, data);
export const putAPICall = async (url, data) => await axiosInstance.put(url, data);
export const deleteAPICall = async (url, data) => await axiosInstance.delete(url, data);